import { LoadingConstants, useLogger } from '@zg-rentals/rental-manager-env';
import {
  AdproductsUserBillingInvoiceApiHandler_getInvoice,
  AdproductsUserBillingInvoicePaymentApiHandler_makeInvoicePaymentV2,
} from '@zg-rentals/ts-adproducts-client';
import React from 'react';
import { type AdproductsZuoraBillingInvoiceDto } from '@zg-rentals/ts-adproducts-client';

export const useInvoice = () => {
  const [invoice, setInvoice] = React.useState<AdproductsZuoraBillingInvoiceDto | null>(null);
  const [loadingState, setLoadingState] = React.useState<LoadingConstants>(LoadingConstants.INITIAL);
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const logger = useLogger();

  const setIsPaymentInProgress = (isPaymentInProgress: boolean) => {
    if (!invoice) return;
    setInvoice({
      ...invoice,
      isPaymentInProgress: isPaymentInProgress,
    });
  };

  const payInvoice = (params: {
    paymentMethodId: string;
    invoiceNumber: string;
    amount?: number;
    version?: string;
    partialPayment?: boolean;
  }) => {
    return AdproductsUserBillingInvoicePaymentApiHandler_makeInvoicePaymentV2(params);
  };

  const fetchInvoice = (invoiceNumber: string) => {
    setLoadingState(LoadingConstants.LOADING);
    setErrorMessage(null);

    AdproductsUserBillingInvoiceApiHandler_getInvoice({ invoiceNumber })
      .then((res) => {
        setInvoice(res);
        setLoadingState(LoadingConstants.SUCCESS);
        return;
      })
      .catch(() => {
        setErrorMessage('Error loading invoice');
        setLoadingState(LoadingConstants.ERROR);
      });
  };

  return React.useMemo(
    () => ({
      invoice,
      fetchInvoice,
      errorMessage,
      loadingState,
      setIsPaymentInProgress,
      payInvoice,
    }),
    [loadingState, errorMessage, invoice],
  );
};
